import { gql } from 'graphql-request'

export const GET_BOOKS_TITLE_AND_ID_BY_USER = gql`
  query GetBooksTitleAndIdByUser($searchText: String) {
    getBooksTitleAndIdByUser(searchText: $searchText) {
      bookId
      bookTitle
    }
  }
`
